$(document).ready(function () {
  // FAQs
  $('.faq_inner .faq_accordian:first-child').addClass('active');
  $('.faq_title').click( function() {
      $(this).parent().siblings().find('.faq_details').slideUp();
      $(this).parent().siblings().removeClass('active');
      $(this).parent().toggleClass('active');
      $(this).next().slideToggle();
  })
  // Contact US
  $('.form_field input,.form_field textarea').focusin(function(){
    $(this).parent().addClass('cnt_fill');
  });
  $('.form_field input,.form_field textarea').focusout(function(){
      $(this).parent().removeClass('cnt_fill');
  });
  $('.form_field input,.form_field textarea').blur(function(){
    if ( $(this).val() ) {
      $(this).parent().addClass('input-filled');
    } else {
      $(this).parent().removeClass('input-filled');
    }
  });

  // View More
$('.product__description span.view_more').click(function(){
    var $parent = $(this).parent();
    var $descriptionMore = $parent.find('.product__description_more');
    
    if ($parent.hasClass('active')) {
        // Collapse the description (slide up)
        $descriptionMore.css('max-height', '95px');
    } else {
        // Expand the description (slide down)
        // Set max-height to a large value temporarily to allow the transition
        $descriptionMore.css('max-height', $descriptionMore[0].scrollHeight + 'px');
    }
    
    // Toggle the active class to track the state
    $parent.toggleClass('active');
});


  
});

$('.aboute_silder_rcol').slick({
  autoplay: true,
  infinite: true,
  autoplaySpeed: 0,
  speed: 12000,
  arrows: false,
  swipe: false,
  slidesToShow: 1,
  cssEase: 'linear',
  pauseOnFocus: false,
  pauseOnHover: false,
  variableWidth: true,
  // adaptiveHeight: true,
  spaceBetween: 20,
  // responsive: [
  //   {
  //     breakpoint: 1440,
  //     settings: {
  //       slidesToShow: 1,
  //       slidesToScroll: 1,
  //     }
  //   },
  //   {
  //     breakpoint: 1024,
  //     settings: {
  //       slidesToShow: 2,
  //       slidesToScroll: 1,
  //     }
  //   },
  //   {
  //     breakpoint: 992,
  //     settings: {
  //        slidesToShow: 3,
  //       slidesToScroll: 1,
  //     }
  //   },
  //   {
  //     breakpoint: 767,
  //     settings: {
  //       slidesToShow: 3,
  //       slidesToScroll: 1,
  //       infinite: true,
  //     }
  //   }    
  // ]
});


$('.collection_inner_info').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  centerMode: true,
  prevArrow: '<button class="slide-arrow prev-arrow"><svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 0.5L0.928932 7.57107L8 14.6421" stroke="#111111"/></svg></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 0.5L8.07107 7.57107L1 14.6421" stroke="#111111"/></svg></button>',
  centerPadding: "240px",
  responsive: [
    {
      breakpoint: 1440,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        centerPadding: "120px",
        dots: false
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        centerPadding: "120px",
        dots: false
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        centerPadding: "120px",
        dots: false
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        centerPadding: "110px",
        dots: false
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        centerPadding: "90px",
        dots: false
      }
    }
    
  ]
});

 $('body .sorting_filter .mobile-facets__summary').click( function(event) {
    event.preventDefault();
    $(this).parent().toggleClass('filter_opeing');
   
    $(this).next().slideToggle();
});

$('.all_btn_st').on('mouseenter', function(e) {
    var parentOffset = $(this).offset(),
    relX = e.pageX - parentOffset.left,
    relY = e.pageY - parentOffset.top;
    $(this).find('span').css({top:relY, left:relX})
}).on('mouseout', function(e) {
    var parentOffset = $(this).offset(),
    relX = e.pageX - parentOffset.left,
    relY = e.pageY - parentOffset.top;
    $(this).find('span').css({top:relY, left:relX})
});

// $(document).ready(function() {
//     let swiperInstance; // Store Swiper instance

//     function initializeSwiper() {
//         if ($(window).width() <= 767) {
//             $('.product__media-list').removeClass('slider');

//             // Destroy previous Swiper instance if it exists
//             if (swiperInstance) {
//                 swiperInstance.destroy(true, true); // Properly destroy Swiper instance
//                 swiperInstance = null; // Reset instance to avoid conflicts
//             }

//             // Initialize Swiper
//             swiperInstance = new Swiper('.swiper-container', {
//               slidesPerView: 1,
//               spaceBetween: 0,
//               grabCursor: true,
//               speed: 500,
//               pagination: {
//                   el: '.swiper-pagination',
//                   clickable: true,
//               },
//               touchEventsTarget: 'container', // Ensures touch gestures are registered
//               allowTouchMove: true, // Enables touch gestures
//           });
//         }
//     }

//     initializeSwiper();
// });



// $(document).ready(function(){
//   if ($(window).width() <= 767) {
//     let $slider = $('.product__media-list');
  
    
//   }
// });

$(document).ready(function(){
   if ($(window).width() <= 767) {
  let $slider = $('.product__media-list');
  $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      infinite: false,
      touchMove: true
     // adaptiveHeight: true
  });
  console.log("Slick Slider Re-initialized on Mobile.");
  // setTimeout(function() {
    var slider_height = $('.product__media-list').height();
    console.log(slider_height, "sdfsddsdd");
    $('.pro_slide_items').css('height', slider_height);
  // }, 2000);
$(window).on('resize', function() {
  let slider_height = $('.product__media-list').height();
  console.log(slider_height);
  $('.pro_slide_items').css('height', slider_height);
});

   }
});